import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "p-field" }
const _hoisted_2 = { class: "p-field-label" }
const _hoisted_3 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_4 = { class: "p-field-radiobutton" }
const _hoisted_5 = { class: "p-field" }
const _hoisted_6 = { class: "p-field-label" }
const _hoisted_7 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_8 = { class: "p-field-radiobutton" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RadioButton = _resolveComponent("RadioButton")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("AppResource.TypeOfObject")), 1),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.typeOptions, (type) => {
        return (_openBlock(), _createBlock("div", {
          key: `option-${type}`
        }, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_RadioButton, {
              id: `type-option-${type}`,
              name: "type-option",
              value: type,
              modelValue: _ctx.roomObject.thermoTypeOfObject,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.roomObject.thermoTypeOfObject = $event))
            }, null, 8, ["id", "value", "modelValue"]),
            _createVNode("label", {
              for: `type-option-${type}`
            }, _toDisplayString(_ctx.getOptionName(type)), 9, ["for"])
          ])
        ]))
      }), 128))
    ]),
    _createVNode("div", _hoisted_5, [
      _createVNode("label", _hoisted_6, _toDisplayString(_ctx.$t("AppResource.AssociatedPump")), 1),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.associatedPumpOptions, (type) => {
        return (_openBlock(), _createBlock("div", {
          key: `option-${type}`
        }, [
          _hoisted_7,
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_RadioButton, {
              id: `pump-option-${type}`,
              name: "pump-option",
              value: type,
              modelValue: _ctx.roomObject.thermoAssociatedPump,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.roomObject.thermoAssociatedPump = $event))
            }, null, 8, ["id", "value", "modelValue"]),
            _createVNode("label", {
              for: `pump-option-${type}`
            }, _toDisplayString(_ctx.getAssociatedPumpOptionName(type)), 9, ["for"])
          ])
        ]))
      }), 128))
    ])
  ], 64))
}